import * as React from 'react';

function SvgBookmark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M5 4V2h14v20.41l-7-7.01-.02.01-.02-.02-.32.37L5 22.39V4zm6.94 8.39l1.35 1.49 1.72 1.9L17 18V4H7v14l2-2.28 1.6-1.82 1.34-1.51z"
      />
    </svg>
  );
}

export default SvgBookmark;
